import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetRequirementStatusResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  onError?: (error: Error) => void
  onSuccess?: (response: GetRequirementStatusResponse) => void
  children?: (response: GetRequirementStatusResponse) => ReactElement
}

const GetRequirementStatusRequest = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/requirement_statuses`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetRequirementStatusRequest
